import styled from "styled-components";
import { Image } from "../common/image";

const Wrapper = styled.div``;

const CheckedOptionTitle = styled.div`
  display: flex;
  align-items: center;
  width: 36vw;
  height: 5vw;
`;

const Title = styled.div`
  margin-left: 1vw;
  display: flex;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 700;
`;

export default function LivingOptionBoxComponent(props: any) {
  const { title, isSelected, setIsSelected } = props;

  const onClickCheck = () => {
    setIsSelected(!isSelected);
  };

  return (
    <Wrapper>
      <CheckedOptionTitle onClick={onClickCheck}>
        <Image
          src={`/icon/${isSelected ? "checked" : "unchecked"}.png`}
          alt="체크박스"
          width={"3.4vw"}
          height={"3.4vw"}
        />
        <Title>{title}</Title>
      </CheckedOptionTitle>
    </Wrapper>
  );
}
